import { render } from "./Rebates.vue?vue&type=template&id=cfbc18f6&scoped=true"
import script from "./Rebates.vue?vue&type=script&lang=js"
export * from "./Rebates.vue?vue&type=script&lang=js"

import "./Rebates.vue?vue&type=style&index=0&id=cfbc18f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfbc18f6"]])

export default __exports__